import { useRef, useState } from 'react'

interface Props {
  src: string
  circle?: boolean
}

export function VideoPlayer({ src, circle = false }: Props) {
  const videoRef = useRef<HTMLVideoElement>(null)
  const [playing, setPlaying] = useState(false)

  const toggle = () => {
    const v = videoRef.current
    if (!v) return
    if (v.paused) { v.play(); setPlaying(true) }
    else { v.pause(); setPlaying(false) }
  }

  if (!circle) {
    return (
      <video
        ref={videoRef}
        src={src}
        controls
        className="max-w-full max-h-64 rounded-lg"
        preload="metadata"
      />
    )
  }

  return (
    <div
      className="relative w-[200px] h-[200px] rounded-full overflow-hidden bg-black cursor-pointer shrink-0"
      onClick={toggle}
    >
      <video
        ref={videoRef}
        src={src}
        loop
        playsInline
        className="w-full h-full object-cover"
        preload="metadata"
        onEnded={() => setPlaying(false)}
      />
      {!playing && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/30">
          <div className="w-14 h-14 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
              <polygon points="5 3 19 12 5 21 5 3"/>
            </svg>
          </div>
        </div>
      )}
    </div>
  )
}
